// entekhab
import E48 from 'assets/html-pwa/Entekhab/icon-48x48.png';
import E72 from 'assets/html-pwa/Entekhab/icon-72x72.png';
import E96 from 'assets/html-pwa/Entekhab/icon-96x96.png';
import E128 from 'assets/html-pwa/Entekhab/icon-128x128.png';
import E144 from 'assets/html-pwa/Entekhab/icon-144x144.png';
import E152 from 'assets/html-pwa/Entekhab/icon-152x152.png';
import E192 from 'assets/html-pwa/Entekhab/icon-192x192.png';
import E386 from 'assets/html-pwa/Entekhab/icon-384x384.png';
import E512 from 'assets/html-pwa/Entekhab/icon-512x512.png';

// darsad
import D48 from 'assets/html-pwa/Darsad/icon-48x48.png';
import D72 from 'assets/html-pwa/Darsad/icon-72x72.png';
import D96 from 'assets/html-pwa/Darsad/icon-96x96.png';
import D128 from 'assets/html-pwa/Darsad/icon-128x128.png';
import D144 from 'assets/html-pwa/Darsad/icon-144x144.png';
import D152 from 'assets/html-pwa/Darsad/icon-152x152.png';
import D192 from 'assets/html-pwa/Darsad/icon-192x192.png';
import D386 from 'assets/html-pwa/Darsad/icon-384x384.png';
import D512 from 'assets/html-pwa/Darsad/icon-512x512.png';

// keepa
import K48 from 'assets/html-pwa/Keepa/icon-48x48.png';
import K72 from 'assets/html-pwa/Keepa/icon-72x72.png';
import K96 from 'assets/html-pwa/Keepa/icon-96x96.png';
import K128 from 'assets/html-pwa/Keepa/icon-128x128.png';
import K144 from 'assets/html-pwa/Keepa/icon-144x144.png';
import K152 from 'assets/html-pwa/Keepa/icon-152x152.png';
import K192 from 'assets/html-pwa/Keepa/icon-192x192.png';
import K386 from 'assets/html-pwa/Keepa/icon-384x384.png';
import K512 from 'assets/html-pwa/Keepa/icon-512x512.png';

// sabalend
import S48 from 'assets/html-pwa/Sabalend/icon-48x48.png';
import S72 from 'assets/html-pwa/Sabalend/icon-72x72.png';
import S96 from 'assets/html-pwa/Sabalend/icon-96x96.png';
import S128 from 'assets/html-pwa/Sabalend/icon-128x128.png';
import S144 from 'assets/html-pwa/Sabalend/icon-144x144.png';
import S152 from 'assets/html-pwa/Sabalend/icon-152x152.png';
import S192 from 'assets/html-pwa/Sabalend/icon-192x192.png';
import S386 from 'assets/html-pwa/Sabalend/icon-384x384.png';
import S512 from 'assets/html-pwa/Sabalend/icon-512x512.png';

// refahyar
import R48 from 'assets/html-pwa/Refahyar/icon-48x48.png';
import R72 from 'assets/html-pwa/Refahyar/icon-72x72.png';
import R96 from 'assets/html-pwa/Refahyar/icon-96x96.png';
import R128 from 'assets/html-pwa/Refahyar/icon-128x128.png';
import R144 from 'assets/html-pwa/Refahyar/icon-144x144.png';
import R152 from 'assets/html-pwa/Refahyar/icon-152x152.png';
import R192 from 'assets/html-pwa/Refahyar/icon-192x192.png';
import R386 from 'assets/html-pwa/Refahyar/icon-384x384.png';
import R512 from 'assets/html-pwa/Refahyar/icon-512x512.png';

// fara
import F48 from 'assets/html-pwa/Fara/fara48x48.png';
import F72 from 'assets/html-pwa/Fara/fara72x72.png';
import F96 from 'assets/html-pwa/Fara/fara96x96.png';
import F128 from 'assets/html-pwa/Fara/fara128x128.png';
import F144 from 'assets/html-pwa/Fara/fara144x144.png';
import F152 from 'assets/html-pwa/Fara/fara152x152.png';
import F192 from 'assets/html-pwa/Fara/fara192x192.png';
import F386 from 'assets/html-pwa/Fara/fara192x192.png';
import F512 from 'assets/html-pwa/Fara/fara512x512.png';

// hamtaland
import H48 from 'assets/html-pwa/Hamtaland/hamtaland - 48-min.png';
import H72 from 'assets/html-pwa/Hamtaland/hamtaland - 72-min.png';
import H96 from 'assets/html-pwa/Hamtaland/hamtaland -96-min.png';
import H128 from 'assets/html-pwa/Hamtaland/hamtaland - 128-min.png';
import H144 from 'assets/html-pwa/Hamtaland/hamtaland - 144-min.png';
import H152 from 'assets/html-pwa/Hamtaland/hamtaland - 152-min.png';
import H192 from 'assets/html-pwa/Hamtaland/hamtaland - 192-min.png';
import H384 from 'assets/html-pwa/Hamtaland/hamtaland - 384-min.png';
import H512 from 'assets/html-pwa/Hamtaland/hamtaland - 512-min.png';

// rayansaipa
import RS48 from 'assets/html-pwa/Rayansaipa/android/android-launchericon-48-48.png';
import RS72 from 'assets/html-pwa/Rayansaipa/android/android-launchericon-72-72.png';
import RS96 from 'assets/html-pwa/Rayansaipa/android/android-launchericon-96-96.png';
import RS144 from 'assets/html-pwa/Rayansaipa/android/android-launchericon-144-144.png';
import RS192 from 'assets/html-pwa/Rayansaipa/android/android-launchericon-192-192.png';
import RS512 from 'assets/html-pwa/Rayansaipa/android/android-launchericon-512-512.png';

// ghestane
import GH48 from 'assets/html-pwa/Ghestane/size48.jpg';
import GH72 from 'assets/html-pwa/Ghestane/size72.jpg';
import GH96 from 'assets/html-pwa/Ghestane/size96.jpg';
import GH128 from 'assets/html-pwa/Ghestane/size128.jpg';
import GH144 from 'assets/html-pwa/Ghestane/size144.jpg';
import GH152 from 'assets/html-pwa/Ghestane/size152.jpg';
import GH192 from 'assets/html-pwa/Ghestane/size176.jpg';
import GH384 from 'assets/html-pwa/Ghestane/size348.jpg';
import GH512 from 'assets/html-pwa/Ghestane/512size.jpg';

// tisa
import Ti48 from 'assets/html-pwa/Tisa/48.png';
import Ti72 from 'assets/html-pwa/Tisa/72.png';
import Ti96 from 'assets/html-pwa/Tisa/96.png';
import Ti128 from 'assets/html-pwa/Tisa/128.png';
import Ti144 from 'assets/html-pwa/Tisa/144.png';
import Ti152 from 'assets/html-pwa/Tisa/152.png';
import Ti192 from 'assets/html-pwa/Tisa/176.png';
import Ti384 from 'assets/html-pwa/Tisa/348.png';
import Ti512 from 'assets/html-pwa/Tisa/512.png';

// saana
import SA48 from 'assets/html-pwa/Saana/48.png';
import SA72 from 'assets/html-pwa/Saana/72.png';
import SA96 from 'assets/html-pwa/Saana/96.png';
import SA128 from 'assets/html-pwa/Saana/128.png';
import SA144 from 'assets/html-pwa/Saana/144.png';
import SA152 from 'assets/html-pwa/Saana/152.png';
import SA192 from 'assets/html-pwa/Saana/176.png';
import SA384 from 'assets/html-pwa/Saana/384.png';
import SA512 from 'assets/html-pwa/Saana/512.png';

// shopp
import Shopp48 from 'assets/html-pwa/Shopp/48.png';
import Shopp72 from 'assets/html-pwa/Shopp/72.png';
import Shopp96 from 'assets/html-pwa/Shopp/96.png';
import Shopp128 from 'assets/html-pwa/Shopp/128.png';
import Shopp144 from 'assets/html-pwa/Shopp/144.png';
import Shopp152 from 'assets/html-pwa/Shopp/152.png';
import Shopp192 from 'assets/html-pwa/Shopp/176.png';
import Shopp384 from 'assets/html-pwa/Shopp/348.png';
import Shopp512 from 'assets/html-pwa/Shopp/512.png';

// arbaeen
import ARB48 from 'assets/html-pwa/Arbaeen/48.png';
import ARB72 from 'assets/html-pwa/Arbaeen/72.png';
import ARB96 from 'assets/html-pwa/Arbaeen/96.png';
import ARB128 from 'assets/html-pwa/Arbaeen/128.png';
import ARB144 from 'assets/html-pwa/Arbaeen/144.png';
import ARB152 from 'assets/html-pwa/Arbaeen/152.png';
import ARB192 from 'assets/html-pwa/Arbaeen/176.png';
import ARB384 from 'assets/html-pwa/Arbaeen/348.png';
import ARB512 from 'assets/html-pwa/Arbaeen/512.png';

// danesh
import Danesh48 from 'assets/html-pwa/Danesh/danesh 48 48.png';
import Danesh72 from 'assets/html-pwa/Danesh/danesh 72 72.png';
import Danesh96 from 'assets/html-pwa/Danesh/danesh 96 96.png';
import Danesh128 from 'assets/html-pwa/Danesh/danesh 128 128.png';
import Danesh144 from 'assets/html-pwa/Danesh/danesh 144 144.png';
import Danesh152 from 'assets/html-pwa/Danesh/danesh 152 152.png';
import Danesh176 from 'assets/html-pwa/Danesh/danesh 176 176.png';
import Danesh192 from 'assets/html-pwa/Danesh/danesh 192 192.png';
import Danesh384 from 'assets/html-pwa/Danesh/danesh 348 384.png';
import Danesh512 from 'assets/html-pwa/Danesh/danesh 512 512.png';
// karma
import Karma48 from 'assets/html-pwa/Karma/48.png';
import Karma72 from 'assets/html-pwa/Karma/72.png';
import Karma96 from 'assets/html-pwa/Karma/96.png';
import Karma128 from 'assets/html-pwa/Karma/128.png';
import Karma144 from 'assets/html-pwa/Karma/144.png';
import Karma176 from 'assets/html-pwa/Karma/176.png';
import Karma192 from 'assets/html-pwa/Karma/192.png';
import Karma384 from 'assets/html-pwa/Karma/384.png';
import Karma512 from 'assets/html-pwa/Karma/512.png';

// hastesh
import Hastesh48 from 'assets/html-pwa/Hastesh/48-48-min.png';
import Hastesh72 from 'assets/html-pwa/Hastesh/72-72-min.png';
import Hastesh96 from 'assets/html-pwa/Hastesh/96-96-min.png';
import Hastesh128 from 'assets/html-pwa/Hastesh/128-128-min.png';
import Hastesh144 from 'assets/html-pwa/Hastesh/144-144-min.png';
import Hastesh152 from 'assets/html-pwa/Hastesh/152-152-min.png';
import Hastesh192 from 'assets/html-pwa/Hastesh/192-192-min.png';
import Hastesh384 from 'assets/html-pwa/Hastesh/384-384-min.png';
import Hastesh512 from 'assets/html-pwa/Hastesh/512-512-min.png';

// arman-pay
import ArmanPay48 from 'assets/html-pwa/Armanpay/48.png';
import ArmanPay72 from 'assets/html-pwa/Armanpay/72.png';
import ArmanPay96 from 'assets/html-pwa/Armanpay/96.png';
import ArmanPay128 from 'assets/html-pwa/Armanpay/128.png';
import ArmanPay144 from 'assets/html-pwa/Armanpay/144.png';
import ArmanPay152 from 'assets/html-pwa/Armanpay/152.png';
import ArmanPay192 from 'assets/html-pwa/Armanpay/192.png';
import ArmanPay384 from 'assets/html-pwa/Armanpay/348.png';
import ArmanPay512 from 'assets/html-pwa/Armanpay/512.png';

// calko
import Calko48 from 'assets/html-pwa/Calko/Calko48.png';
import Calko72 from 'assets/html-pwa/Calko/Calko72.png';
import Calko96 from 'assets/html-pwa/Calko/Calko96.png';
import Calko128 from 'assets/html-pwa/Calko/Calko128.png';
import Calko144 from 'assets/html-pwa/Calko/Calko144.png';
import Calko152 from 'assets/html-pwa/Calko/Calko152.png';
import Calko192 from 'assets/html-pwa/Calko/Calko192.png';
import Calko384 from 'assets/html-pwa/Calko/Calko384.png';
import Calko512 from 'assets/html-pwa/Calko/Calko512.png';

// lendavid
import L48 from 'assets/html-pwa/Lendavid/48-48.png';
import L72 from 'assets/html-pwa/Lendavid/72-72.png';
import L96 from 'assets/html-pwa/Lendavid/96-96.png';
import L128 from 'assets/html-pwa/Lendavid/128-128.png';
import L144 from 'assets/html-pwa/Lendavid/144-144.png';
import L152 from 'assets/html-pwa/Lendavid/152-152.png';
import L192 from 'assets/html-pwa/Lendavid/192-192.png';
import L348 from 'assets/html-pwa/Lendavid/348-348.png';
import L512 from 'assets/html-pwa/Lendavid/512-512.png';

// flyToday
import Fly16 from 'assets/html-pwa/Flytoday/16.png';
import Fly48 from 'assets/html-pwa/Flytoday/48.png';
import Fly72 from 'assets/html-pwa/Flytoday/72.png';
import Fly96 from 'assets/html-pwa/Flytoday/96.png';
import Fly128 from 'assets/html-pwa/Flytoday/128.png';
import Fly144 from 'assets/html-pwa/Flytoday/144.png';
import Fly152 from 'assets/html-pwa/Flytoday/152.png';
import Fly176 from 'assets/html-pwa/Flytoday/176.png';
import Fly192 from 'assets/html-pwa/Flytoday/192.png';
import Fly384 from 'assets/html-pwa/Flytoday/384.png';
import Fly512 from 'assets/html-pwa/Flytoday/512.png';

// can
import Can16 from 'assets/html-pwa/Can/16x16.png';
import Can48 from 'assets/html-pwa/Can/48x48.png';
import Can72 from 'assets/html-pwa/Can/72x72.png';
import Can96 from 'assets/html-pwa/Can/96x96.png';
import Can128 from 'assets/html-pwa/Can/128x128.png';
import Can144 from 'assets/html-pwa/Can/144x144.png';
import Can152 from 'assets/html-pwa/Can/152x152.png';
import Can176 from 'assets/html-pwa/Can/176x176.png';
import Can192 from 'assets/html-pwa/Can/192x192.png';
import Can384 from 'assets/html-pwa/Can/348x348.png';
import Can512 from 'assets/html-pwa/Can/512x512.png';
// All other icon imports...

export const entekhabIcons = {
	48: E48,
	72: E72,
	96: E96,
	128: E128,
	144: E144,
	152: E152,
	192: E192,
	384: E386,
	512: E512,
};

export const darsadIcons = {
	48: D48,
	72: D72,
	96: D96,
	128: D128,
	144: D144,
	152: D152,
	192: D192,
	384: D386,
	512: D512,
};

export const keepaIcons = {
	48: K48,
	72: K72,
	96: K96,
	128: K128,
	144: K144,
	152: K152,
	192: K192,
	384: K386,
	512: K512,
};

export const sabalendIcons = {
	48: S48,
	72: S72,
	96: S96,
	128: S128,
	144: S144,
	152: S152,
	192: S192,
	384: S386,
	512: S512,
};

export const refahyarIcons = {
	48: R48,
	72: R72,
	96: R96,
	128: R128,
	144: R144,
	152: R152,
	192: R192,
	384: R386,
	512: R512,
};

export const faraIcons = {
	48: F48,
	72: F72,
	96: F96,
	128: F128,
	144: F144,
	152: F152,
	192: F192,
	384: F386,
	512: F512,
};

export const hamtalandIcons = {
	48: H48,
	72: H72,
	96: H96,
	128: H128,
	144: H144,
	152: H152,
	192: H192,
	384: H384,
	512: H512,
};

export const rayansaipaIcons = {
	48: RS48,
	72: RS72,
	96: RS96,
	144: RS144,
	192: RS192,
	512: RS512,
};

export const ghestanehIcons = {
	48: GH48,
	72: GH72,
	96: GH96,
	128: GH128,
	144: GH144,
	152: GH152,
	192: GH192,
	384: GH384,
	512: GH512,
};

export const tisaIcons = {
	48: Ti48,
	72: Ti72,
	96: Ti96,
	128: Ti128,
	144: Ti144,
	152: Ti152,
	192: Ti192,
	384: Ti384,
	512: Ti512,
};

export const saanaIcons = {
	48: SA48,
	72: SA72,
	96: SA96,
	128: SA128,
	144: SA144,
	152: SA152,
	192: SA192,
	384: SA384,
	512: SA512,
};

export const shoppIcons = {
	48: Shopp48,
	72: Shopp72,
	96: Shopp96,
	128: Shopp128,
	144: Shopp144,
	152: Shopp152,
	192: Shopp192,
	384: Shopp384,
	512: Shopp512,
};

export const arbaeenIcons = {
	48: ARB48,
	72: ARB72,
	96: ARB96,
	128: ARB128,
	144: ARB144,
	152: ARB152,
	192: ARB192,
	384: ARB384,
	512: ARB512,
};

export const daneshIcons = {
	48: Danesh48,
	72: Danesh72,
	96: Danesh96,
	128: Danesh128,
	144: Danesh144,
	152: Danesh152,
	176: Danesh176,
	192: Danesh192,
	384: Danesh384,
	512: Danesh512,
};

export const karmaIcons = {
	48: Karma48,
	72: Karma72,
	96: Karma96,
	128: Karma128,
	144: Karma144,
	176: Karma176,
	192: Karma192,
	384: Karma384,
	512: Karma512,
};

export const hasteshIcons = {
	48: Hastesh48,
	72: Hastesh72,
	96: Hastesh96,
	128: Hastesh128,
	144: Hastesh144,
	152: Hastesh152,
	192: Hastesh192,
	384: Hastesh384,
	512: Hastesh512,
};

export const armanpayIcons = {
	48: ArmanPay48,
	72: ArmanPay72,
	96: ArmanPay96,
	128: ArmanPay128,
	144: ArmanPay144,
	152: ArmanPay152,
	192: ArmanPay192,
	384: ArmanPay384,
	512: ArmanPay512,
};

export const calkoIcons = {
	48: Calko48,
	72: Calko72,
	96: Calko96,
	128: Calko128,
	144: Calko144,
	152: Calko152,
	192: Calko192,
	384: Calko384,
	512: Calko512,
};

export const lendavidIcons = {
	48: L48,
	72: L72,
	96: L96,
	128: L128,
	144: L144,
	152: L152,
	192: L192,
	384: L348,
	512: L512,
};

export const flyTodayIcons = {
	16: Fly16,
	48: Fly48,
	72: Fly72,
	96: Fly96,
	128: Fly128,
	144: Fly144,
	152: Fly152,
	176: Fly176,
	192: Fly192,
	384: Fly384,
	512: Fly512,
};

export const canIcons = {
	16: Can16,
	48: Can48,
	72: Can72,
	96: Can96,
	128: Can128,
	144: Can144,
	152: Can152,
	176: Can176,
	192: Can192,
	384: Can384,
	512: Can512,
};

// Export other icon sets similarly...
